// ##############################
// // // Pages
// #############################
import { HomeRoutes } from './Home/Routes';
import { ScreenManagerRoutes } from './ScreenManager/Routes';
import { ArtworkRoutes } from './Artwork/Routes';
import { FileUploadRoutes } from './FileUpload/Routes';
import { MediafilesRoutes } from './MediaFiles/Routes';
import { UserMessagesRoutes } from './UserMessages/Routes';
import { CollectionsRoutes } from './Collections/Routes';
import { MyFilesRoutes } from './MyFiles/Routes';
import { AdminRoutes } from './Admin/Routes';
import { SSOLoginRoutes } from './SSOLogin/Routes';
import { LoginRoutes } from './Login/Routes';
import { ForgotPasswordRoutes } from './ForgotPassword/Routes';
import { ResetPasswordRoutes } from './ResetPassword/Routes';

export const pageRoutes = [
	...HomeRoutes,
	...ScreenManagerRoutes,
	...ArtworkRoutes,
	...FileUploadRoutes,
	...MediafilesRoutes,
	...UserMessagesRoutes,
	...CollectionsRoutes,
	...MyFilesRoutes,
	...AdminRoutes,
	...SSOLoginRoutes,
	...LoginRoutes,
	...ForgotPasswordRoutes,
	...ResetPasswordRoutes,
];
